import { forwardRef } from 'react';
import { Chip, type ChipProps } from '@/ui_v3/components/chip/Chip';
import { cn } from '@/utils';
interface NewChipProps extends ChipProps {
  variant?: 'filled' | 'outlined';
}
export const NewChip = forwardRef<HTMLSpanElement, NewChipProps>((props, ref) => {
  const {
    className,
    variant = 'filled',
    ...rest
  } = props;
  return <Chip ref={ref} size="xs" rounded="full" className={cn('border', variant === 'outlined' && 'text-destructive border-destructive bg-default', variant === 'filled' && 'text-inverse bg-red-400 border-opacity-assistive', className)} {...rest}>
        New
      </Chip>;
});
NewChip.displayName = 'NewChip';